// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__kPDbo","content":"ManualTimeModal_content__1PjY-"};